import { Button, Topbar, Typography } from '@sonnen/web-ui';
import { useAuth } from '@sonnen/web-utils/hooks';
import { memo, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../AppContext/AppContext';
import { AppRoute } from '../../constants';
import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import { useTranslation } from '../../i18n/i18n';
import { CurrentUser } from '../../types';
import { getFullName, getLogoutRedirectUri } from '../../utils/utils';
import styles from './TopbarWithNameAndLogout.module.css';

const LinkComponent = ({ children }: PropsWithChildren) => {
  const { user } = useAppContext();
  const targetRoute = user ? AppRoute.ENERGY_STORE : AppRoute.ROOT;
  return <Link to={targetRoute}>{children}</Link>;
};

const TopbarWithNameAndLogoutBtn = () => {
  const { authenticated } = useAuth();
  const { user, userProcessing } = useAppContext();
  const { logout } = useAuth<CurrentUser>();
  const { t } = useTranslation();
  const redirectUri = getLogoutRedirectUri();
  const currentRoute = useCurrentRoute();

  return (
    <Topbar roundedCorners={currentRoute === AppRoute.ROOT} LinkComponent={LinkComponent}>
      <div className={styles.topbarWithNameAndLogout}>
        {user && !userProcessing && (
          <Typography.Body1 truncate>{getFullName(user.contact)}</Typography.Body1>
        )}

        {authenticated && currentRoute !== AppRoute.MAINTENANCE && (
          <Button
            label={t('logoutButtonLabel')}
            dataTestId="logout-btn"
            variant="secondary"
            onClick={() => logout(redirectUri)}
            size="small"
          />
        )}
      </div>
    </Topbar>
  );
};

export default memo(TopbarWithNameAndLogoutBtn);
